import {skeletonGet} from './skeleton/skeletonGet';
import {DeleteAlertMarketPayload, GetOddHistoryPayload} from "../@types/actions";
import {skeletonDelete} from "./skeleton/skeletonDelete";
import {EventMainObject} from "../@types/response";

const eventEndpoint = 'mo/event'

export const GetEventCall = ({eventId}: { eventId: number }): Promise<EventMainObject> => {
    return skeletonGet(`${eventId}/main`, eventEndpoint) as Promise<EventMainObject>;
};

export const GetActiveEventsCall = (): Promise<any> => {
    return skeletonGet('active', eventEndpoint);
};

export const GetOddHistoryCall = (payload: GetOddHistoryPayload): Promise<any> => {
    const query = `b=${payload.bookmakerId}&m=${payload.marketId}&s=${payload.signId}${!payload.spread || payload.spread === '#' ? '' : `&p=${payload.spread}`}`
    return skeletonGet(`odd-history/${payload.eventId}?${query}`, eventEndpoint);
};

export const GetEventsRawCall = (): Promise<any> => {
    return skeletonGet('', eventEndpoint);
};

export const DeleteAlertCall = (payload: DeleteAlertMarketPayload): Promise<any> => {
    return skeletonDelete(`${payload.eventId}/${payload.bookmakerId}/${payload.marketId}${payload.sbv ? '@' + payload.sbv : ''}`, eventEndpoint);
};